module.exports = __webpack_public_path__ + "Server-Disabled.Ftp.bb6a03c604200205e504a9bdc8f97232.hashedasset.svg";